import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { FormControl, FormControlProps } from 'react-bootstrap';
import { BsPrefixRefForwardingComponent } from 'react-bootstrap/esm/helpers';
import { Box } from '../../Box';
import { Typography } from '../../Typography';
import styles from './LimitedTextarea.module.scss';

export type FormLimitedTextareaProps = BsPrefixRefForwardingComponent<'textarea', FormControlProps> &
	FormControlProps & {
		maxLength: number;
		value?: string;
	};

export const FormLimitedTextarea: FC<FormLimitedTextareaProps> = ({ maxLength, value = '', onChange, children, ...props }) => {
	const [content, setContent] = useState(value.slice(0, maxLength));
	const setFormattedContent = React.useCallback(
		(text) => {
			setContent(text.slice(0, maxLength));
		},
		[maxLength, setContent],
	);

	return (
		<Box className={classNames(styles.limitedTextarea, 'limitedTextarea')}>
			<FormControl
				{...props}
				onChange={(event) => {
					setFormattedContent(event.target.value);

					if (onChange) {
						onChange(event);
					}
				}}
				maxLength={maxLength}
				size="lg"
				as="textarea"
				value={content}
			/>

			<Typography variant="perex" className={styles.limitedTextareaCount}>
				{content.length} / {maxLength}
			</Typography>
		</Box>
	);
};
